import { useSelector } from 'react-redux';

import { WithSkeleton } from '@r1-frontend/ui-react/components/loaders/Skeleton';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import TextWrapper from '@r1-frontend/ui-react/components/typography/TextWrapper';

import { EEntity } from '~/src/features/tariffBuilder//types/EEntity';
import ConnectedEntitiesContainer from '~/src/features/tariffBuilder/containers/ConnectedEntitiesContainer';
import TvSubscriptionsContainer from '~/src/features/tariffBuilder/containers/TvSubscriptionsContainer';
import { selectCompanyName } from '~/src/store/selectors/city';

const TvBlock = (): JSX.Element => {
    const companyName = useSelector(selectCompanyName);

    return (
        <>
            <TextWrapper>
                <H3>ТВ-каналы</H3>
                <Paragraph4 $smaller>
                    Много и&nbsp;все про разное: спорт, кино, путешествия, хобби. Для взрослых и&nbsp;детей.
                    Стоимость каждого пакета ТВ-каналов в&nbsp;тарифе Конструктор ниже благодаря скидке от&nbsp;{companyName}.
                </Paragraph4>
            </TextWrapper>

            <ConnectedEntitiesContainer entityName={EEntity.tv}/>

            <WithSkeleton height={200}>
                <TvSubscriptionsContainer/>
            </WithSkeleton>
        </>
    );
};

export default TvBlock;
